import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { MessageDetail, MessageTemplateItem } from '@oracle/oraclejet-preact/UNSAFE_Message';

const messageTemplateItem = {
  data: {
    detail: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
  },
  index: 0,
  key: 'ConfirmationMessage',
  metadata: { key: 'ConfirmationMessage' }
};

describe('Test MessageDetail component', () => {
  it('default renderer', async function () {
    const content = render(
      <MessageDetail
        item={messageTemplateItem}
      />
    );

    const detail = await content.findByText('Lorem Ipsum is simply dummy text of the printing and typesetting industry.');
    expect(detail).not.null;
  });

  it('custom renderer', async function () {
    type DataType = {
      detail: string
    };
    const detailRenderer = ({ data, index, key, metadata }: MessageTemplateItem<string, DataType>) => (
      <div style='border: 1px solid gray; padding: 5px; background-color: orange;'
        data-testid='customWrapper'>
        <div>index: {index}</div>
        <div>key: {key}</div>
        <div>detail: {data.detail}</div>
        <div>metadata key: {metadata?.key}</div>
      </div>
    );

    const content = render(
      <MessageDetail
        item={messageTemplateItem}
        renderer={detailRenderer}
      />
    );

    const customWrapper = await content.findByTestId('customWrapper');
    expect(customWrapper).not.null;
    expect(customWrapper?.style.backgroundColor).to.equal('orange');

    const index = await content.findByText('index: 0');
    expect(index).not.null;

    const key = await content.findByText('key: ConfirmationMessage');
    expect(key).not.null;

    const detail = await content.findByText('detail: Lorem Ipsum is simply dummy text of the printing and typesetting industry.');
    expect(detail).not.null;

    const metadataKey = await content.findByText('metadata key: ConfirmationMessage');
    expect(metadataKey).not.null;
  });
});
